import React, { useContext } from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { Button, Typography } from 'antd'
import { EditFilled, CloseOutlined } from '@ant-design/icons'

import { FlexRow, FlexColumn } from '../FlexboxReusables/FlexItems'
import ChangeProfilePicture from '../User/ChangeProfilePicture'
import { AuthContext } from '../Auth/AuthContext'
import { UserRole } from '../User/types'

type ClientProfileSummarySegmentProps = {
  id: number
  companyName: string
  setEditProfilePicture: (editProfilePicture: boolean) => void
  editProfilePicture: boolean
}

const ClientProfileSummarySegment: React.FC<ClientProfileSummarySegmentProps> = (
  {
    id,
    companyName,
    setEditProfilePicture,
    editProfilePicture
  }: ClientProfileSummarySegmentProps) => {
  const { authUser, translateUserRole } = useContext(AuthContext)

  return (
    <>
      <FlexRow width='100%' justifyContent='space-evenly' alignItems='flex-start'>
        <FlexColumn width='20%'>
          <ChangeProfilePicture editMode={editProfilePicture} />
          <Button
            type='primary'
            onClick={() => setEditProfilePicture(!editProfilePicture)}
            style={{ marginTop: '1em'}}
          >
            {!editProfilePicture ? <EditIcon /> : <EndEditIcon />}
            <FormattedMessage id='generic.edit' />
          </Button>
        </FlexColumn>
        <FlexColumn width='20%'>
          <FlexRow justifyContent='flex-start'>
            <Typography.Title level={5}>
              {companyName}
            </Typography.Title>
          </FlexRow>
        </FlexColumn>

        <FlexColumn alignItems='flex-start' width='20%'>
          <FlexRow justifyContent='flex-start'>
            <Typography.Title level={4}>
              <FormattedMessage id='generic.role' />:{' '}
              {translateUserRole(authUser.role.toLowerCase() as UserRole)}
            </Typography.Title>
          </FlexRow>
          <FlexRow justifyContent='flex-start'>
          User Id: {id}
          </FlexRow>
        </FlexColumn>
      </FlexRow>
    </>
  )
}

export default ClientProfileSummarySegment

const EditIcon = styled(EditFilled)`
  margin-right: 1em;
`

const EndEditIcon = styled(CloseOutlined)`
  margin-right: 1em;
`